import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Input,
  Label,
  Form,
} from "reactstrap";
import * as ApiManager from "helpers/ApiManager.tsx";
import { toast } from "react-toastify";

function TransferStats() {
  const nameRef = useRef();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    if (loading) return;
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    const Name = nameRef.current.value;

    try {
      const res = await ApiManager.TransferStats({
        Name,
      });

      if (res && res.status === "success") {
        navigate("/me");
        toast.success("Transfer stats complete");
      } else {
        setErrorMsg(res.message);
      }
    } catch (err) {
      setErrorMsg("Unknown error occured. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h3">Transfer Stats</CardTitle>
      </CardHeader>
      <CardBody>
        {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="name" className="text-primary mt-2">
              Enter the nick you want to transfer to
            </Label>
            <Input
              type="text"
              id="name"
              placeholder="Enter name"
              innerRef={nameRef}
              required
              className="mt-3"
            />
          </FormGroup>

          <Button color="primary" block disabled={loading}>
            {loading ? "Loading..." : "Transfer Stats"}
          </Button>
          <h4
            className="text-danger text-center pt-4"
            style={{
              fontWeight: "bold",
            }}
          >
            Important: You can transfer stats once every 14 days!
          </h4>
        </Form>
      </CardBody>
    </Card>
  );
}

export default TransferStats;
